/* unplugin-vue-components disabled */import script from "./SellingDisabled.vue?vue&type=script&lang=ts&setup=true"
export * from "./SellingDisabled.vue?vue&type=script&lang=ts&setup=true"

import "./SellingDisabled.vue?vue&type=style&index=0&id=c4531198&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4531198"]])

export default __exports__